var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-comment-list"},[(_vm.loading)?_c('app-loading'):_vm._e(),_vm._l((_vm.list),function(item){return [_c('comment-item',{key:item.id,attrs:{"data":item},on:{"comment-success":_vm.handleCommentSuccess}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }